import $ from 'jquery'

import BaseComponent from 'scripts/components/base-component'

const DEFAULTS = {
  selectors: {
    days: '[data-countdown-days]',
    hours: '[data-countdown-hours]',
    minutes: '[data-countdown-minutes]',
    seconds: '[data-countdown-seconds]'
  }
}

const MILISECONDS = 1000
const SECONDS = 60
const MINUTES = 60
const HOURS = 24

class Countdown extends BaseComponent {
  static componentName = 'countdown'

  constructor (element, options = {}) {
    super(element)

    this.options = $.extend({}, DEFAULTS, options)
  }

  init () {
    this.setupElements()
    this.updateElements()
    this.startCountdown()
  }

  setupElements () {
    const { days, hours, minutes, seconds } = this.options.selectors
    const $element = this.$element

    this.$days = $element.find(days)
    this.$hours = $element.find(hours)
    this.$minutes = $element.find(minutes)
    this.$seconds = $element.find(seconds)
  }

  getRemainingTime () {
    const { deadline } = this.options
    const timestamp = ~~(Date.parse(deadline) - Date.now())

    const totalSeconds = timestamp / MILISECONDS
    const totalMinutes = timestamp / (MILISECONDS * SECONDS)
    const totalHours = timestamp / (MILISECONDS * SECONDS * MINUTES)
    const totalDays = timestamp / (MILISECONDS * SECONDS * MINUTES * HOURS)

    const seconds = Math.floor(totalSeconds % SECONDS)
    const minutes = Math.floor(totalMinutes % MINUTES)
    const hours = Math.floor(totalHours % HOURS)
    const days = Math.floor(totalDays)

    return {
      timestamp,
      seconds,
      minutes,
      hours,
      days
    }
  }

  startCountdown () {
    this.interval = setInterval(this.updateElements.bind(this), 1000)
  }

  stopCountdown () {
    clearInterval(this.interval)
  }

  updateElements () {
    const {
      timestamp,
      days,
      hours,
      minutes,
      seconds
    } = this.getRemainingTime()

    if (timestamp <= 0) {
      return this.stopCountdown()
    }

    this.$days.text(`${days}`.padStart(2, '0'))
    this.$hours.text(`${hours}`.padStart(2, '0'))
    this.$minutes.text(`${minutes}`.padStart(2, '0'))
    this.$seconds.text(`${seconds}`.padStart(2, '0'))
  }
}

export default ($el) => new Countdown($el, $el.data()).init()

export { Countdown as Component }
